var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#00b885"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2478_107895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7771 9.57833L10.9863 9.43673C12.1538 8.68773 13.6991 8.95093 14.5965 10.051L15.8248 11.5625C16.5873 12.5005 16.6952 13.8232 16.0811 14.8557L15.0756 16.563C14.9137 16.8328 15.3927 17.69 16.5872 18.8977C17.7951 20.0923 18.6523 20.5713 18.9289 20.4163L20.6295 19.4038C21.6687 18.7966 22.9846 18.8977 23.9293 19.667L25.4409 20.8953C26.5409 21.7928 26.8041 23.3382 26.0483 24.4988L25.9133 24.7149C24.8877 26.3074 22.9779 27.2588 21.0547 26.9149C18.5645 26.4625 15.9867 24.8837 13.2875 22.1979C10.6084 19.5053 9.02264 16.9208 8.57724 14.4374C8.23314 12.5141 9.18454 10.6042 10.7771 9.57833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.02 9.01983C22.7481 8.97063 22.4881 9.15143 22.4392 9.42333C22.3901 9.69493 22.5708 9.95493 22.8427 10.0041C24.7666 10.3402 26.3477 12.159 26.4818 14.1149C26.4927 14.2664 26.4956 14.4182 26.4897 14.5699C26.4786 14.8459 26.6935 15.0784 26.9696 15.0893C27.2455 15.1002 27.4781 14.8855 27.4891 14.6095C27.4965 14.419 27.4928 14.2293 27.479 14.0421C27.2931 11.6178 25.4348 9.46613 23.02 9.01983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.313 11.1996C22.0411 11.1507 21.7811 11.3312 21.7323 11.6031C21.6834 11.875 21.864 12.135 22.1359 12.1839C23.2252 12.369 24.1451 13.4244 24.2176 14.538L24.2221 14.7972C24.2114 15.0731 24.4264 15.3054 24.7025 15.3161C24.9784 15.3268 25.2108 15.1118 25.2215 14.8359C25.2261 14.7117 25.2238 14.5878 25.2149 14.4653C25.0905 12.8832 23.8934 11.4949 22.313 11.1996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2478_107895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.73a1775343295f128beab6d186baa9cd.svg";
export { ForwardRef as ReactComponent };